import { computed } from "mobx"

import { BaseModel } from "./base.model"

export class AnalyticsModel extends BaseModel {
  async postInit() {
    if (process.env.NODE_ENV === "production") {
      this.initGTM()
      this.initYandex()
      this.initGoogle()
      this.globalShortView()
      this.globalMediumView()
      this.globalLongView()
      this.globalMaxView()

      if (this.isAmp) {
        this.initAmpMetrika()
        this.initAmpAnalytics()
        this.initGoogleAnalytics()
      }
    }
  }

  @computed get isAmp() {
    return new URL(window.location.href).searchParams.has("amp")
  }

  initGTM = () => {
    const gtmScript = document.createElement("script")
    gtmScript.async = true
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5V5BZQR');
    `

    const gtmNoscript = document.createElement("noscript")
    gtmNoscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5V5BZQR"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `

    document.head.append(gtmScript)
    document.body.append(gtmNoscript)
  }

  initAmpAnalytics = () => {
    const script = document.createElement("script")
    script.async = true
    script["custom-element"] = "amp-analytics"
    script.src = "https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
    document.body.prepend(script)
  }

  initGoogleAnalytics = () => {
    const googleAnalyticsNode = document.createElement("amp-analytics")
    googleAnalyticsNode["type"] = "googleanalytics"
    const script = document.createElement("script")
    script.type = "application/json"
    script.innerHTML = `{"vars": {"account": "UA-71088554-12"},"triggers": {"trackPageview": {"on": "visible","request": "pageview"}}}`
    googleAnalyticsNode.append(script)
    document.body.prepend(googleAnalyticsNode)
  }

  initAmpMetrika = () => {
    const ampMetrikaNode = document.createElement("amp-analytics")
    ampMetrikaNode.setAttribute("type", "metrika")
    const script = document.createElement("script")
    script.type = "application/json"
    script.innerHTML = `{"vars": {"counterId": "52677589","yaParams": "{"key":"value","__ymu":{"user_param_key":"user_param_value"}}"},"triggers": {"notBounce": {"on": "timer","timerSpec": {"immediate": false,"interval": 15,"maxTimerLength": 16},"request": "notBounce"},"halfScroll": {"on": "scroll","scrollSpec": {"verticalBoundaries": [50]},"request": "reachGoal","vars": {"goalId": "halfScrollGoal"}},"partsScroll": {"on": "scroll","scrollSpec": {"verticalBoundaries": [25,90]},"request": "reachGoal","vars": {"goalId": "partsScrollGoal"}}}}`
    ampMetrikaNode.append(script)
    document.body.prepend(ampMetrikaNode)
  }

  initYandex = () => {
    const first = document.createElement("script")
    first.async = true
    first.innerHTML = `
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
          m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(52677589, "init", {
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true,
          webvisor:true
        });
    `
    const second = document.createElement("noscript")
    second.innerHTML = `
      <div><img src="https://mc.yandex.ru/watch/52677589" style="position:absolute; left:-9999px;" alt="" /></div>
    `
    document.body.appendChild(first)
    document.body.appendChild(second)
  }

  initGoogle = () => {
    const first = document.createElement("script")
    first.async = true
    const COUNTER_ID = this.Models.GlobalModel.isPureDating
      ? "UA-71088554-16"
      : "UA-71088554-12"
    first.innerHTML = `
      window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
      ga('create', '${COUNTER_ID}', 'auto');
      ga('send', 'pageview');
    `
    const second = document.createElement("script")
    second.async = true
    second.src = "https://www.google-analytics.com/analytics.js"
    second.async = true
    document.body.appendChild(first)
    document.body.appendChild(second)
  }

  globalShortView = () => {
    setTimeout(() => {
      this.Providers.AnalyticProvider.sendYandexEvent({
        value: "short_view",
      })
      this.Providers.AnalyticProvider.sendGoogleEvent({
        action: "view",
        category: "short",
      })
    }, 5000)
  }

  globalMediumView = () => {
    setTimeout(() => {
      this.Providers.AnalyticProvider.sendYandexEvent({
        value: "medium_view",
      })
      this.Providers.AnalyticProvider.sendGoogleEvent({
        action: "view",
        category: "medium",
      })
    }, 30001)
  }

  globalLongView = () => {
    setTimeout(() => {
      this.Providers.AnalyticProvider.sendYandexEvent({
        value: "long_view",
      })
      this.Providers.AnalyticProvider.sendGoogleEvent({
        action: "view",
        category: "long",
      })
    }, 60001)
  }

  globalMaxView = () => {
    setTimeout(() => {
      this.Providers.AnalyticProvider.sendYandexEvent({
        value: "max_view",
      })
      this.Providers.AnalyticProvider.sendGoogleEvent({
        action: "view",
        category: "max",
      })
    }, 300001)
  }

  footerWatcher = false
  footerAnalytic = (footer: HTMLDivElement) => {
    const observerFooter = new IntersectionObserver(
      (entries) => {
        if (entries[0] && entries[0].isIntersecting && !this.footerWatcher) {
          this.footerWatcher = true

          this.Providers.AnalyticProvider.sendYandexEvent({
            value: "footer_show",
          })
          this.Providers.AnalyticProvider.sendGoogleEvent({
            action: "show",
            category: "footer",
          })
        }
      },
      { threshold: 0 },
    )
    observerFooter.observe(footer)
  }

  globalNotFoundPageView = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "error.view.404page",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "view",
      label: "404page",
      category: "error",
    })
  }

  sendRecommendedArticleEvents = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "journal.click.recommended",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "recommended",
      category: "journal",
    })
  }

  subscribeFooterSubmitClick = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "subscribe.click.footer",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "footer",
      category: "subscribe",
    })
  }

  subscribePopUpSubmitClick = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "subscribe.click.popup",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "popup",
      category: "subscribe",
    })
  }

  faqSearchOpenerClickHandler = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "faq.click.search",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "search",
      category: "faq",
    })
  }
  faqTableOfContentsClickHandler = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "faq.click.section",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "section",
      category: "faq",
    })
  }
  faqSearchResultPaginationNextClickHandler = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "faq.click.next_result",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "next_result",
      category: "faq",
    })
  }
  faqSearchResultPaginationPrevClickHandler = () => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "faq.click.previous_result",
    })
    this.Providers.AnalyticProvider.sendGoogleEvent({
      action: "click",
      label: "previous_result",
      category: "faq",
    })
  }

  articleShareClickHandler = (type: ArticleShareType) => {
    this.Providers.AnalyticProvider.sendYandexEvent({
      value: "journal.click.share",
      params: {
        type: `${type}_${this.Models.GlobalModel.lang}`,
      },
    })
  }
}

export type ArticleShareType =
  | "telegram"
  | "twitter"
  | "facebook"
  | "vk"
  | "whatsapp"
  | "copy_link"
